/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Cell, colors, Grid, Heading, InfoLabel, VFlow } from 'bold-ui'
import { CaracteristicaLesaoEnum } from 'graphql/types.generated'

import { getTecidosMolesCaracteristicaLesao, getTipoLesaoFundamental } from '../../model'
import { CaracteristicasLesaoFieldModel } from './CaracteristicasLesaoField'

interface CaracteristicasLesaoPanelProps {
  item: CaracteristicasLesaoFieldModel
}

const renderTitle = (value: CaracteristicaLesaoEnum) => value && getTecidosMolesCaracteristicaLesao(value).title

export function CaracteristicasLesaoPanel(props: CaracteristicasLesaoPanelProps) {
  const { item } = props

  if (!item) return null

  return (
    <div
      css={css`
        padding: 1rem;
        background: ${colors.gray.c90};
      `}
    >
      <VFlow vSpacing={0.5}>
        <Heading level={4}>Características da lesão</Heading>

        <Grid>
          <Cell size={4}>
            <VFlow vSpacing={0.5}>
              <InfoLabel title='Lesão fundamental'>
                {item.lesaoFundamental?.value && getTipoLesaoFundamental(item.lesaoFundamental.value).title}
              </InfoLabel>

              <InfoLabel title='Quantidade'>{renderTitle(item.quantidade)}</InfoLabel>

              <InfoLabel title='Tamanho'>{renderTitle(item.tamanho)}</InfoLabel>

              <InfoLabel title='Superfície'>{item.superficie?.label}</InfoLabel>

              <InfoLabel title='Sintamotologia'>
                {item.sintamotologia?.value === 'outros'
                  ? `Outro: ${item.sintamotologia?.descricaoOutro}`
                  : renderTitle(item.sintamotologia?.value)}
              </InfoLabel>
            </VFlow>
          </Cell>

          <Cell size={8}>
            <VFlow vSpacing={0.5}>
              {item.lesaoFundamental?.value && (
                <InfoLabel title={getTipoLesaoFundamental(item.lesaoFundamental?.value).lesaoEnvolvidaTitle}>
                  {renderTitle(item.lesaoFundamental.lesaoEnvolvida)}
                </InfoLabel>
              )}

              <InfoLabel title='Implantação ou base'>{renderTitle(item.base)}</InfoLabel>

              <InfoLabel title='Cor'>{renderTitle(item.cor)}</InfoLabel>

              <InfoLabel title='Consistência'>{renderTitle(item.consistencia)}</InfoLabel>
            </VFlow>
          </Cell>
        </Grid>
      </VFlow>
    </div>
  )
}
